<template>
    <div class="content-body">
        <template v-if="subscription && user">
            <voyage :user="user" :subscription="subscription" v-if="subscription.product_id == '3' || subscription.product_id == 3"/>
            <auto :user="user" :guarantees="guarantees" :subscription="subscription" v-else-if="subscription.product_id == '1' || subscription.product_id == 1"/>
            <habitation :user="user" :subscription="subscription" v-else-if="subscription.product_id == '2' || subscription.product_id == 2"/>
            <div v-else class="alert alert-warning" role="alert">
                <div class="alert-body">
                    Type de souscription non reconnu (product_id: {{ subscription.product_id }}).
                </div>
            </div>
        </template>
        <div v-else class="alert alert-warning" role="alert">
            <div class="alert-body">
                Souscription non trouvée ou données invalides.
            </div>
        </div>
    </div>
</template>

<script>
import voyage from './details/voyage.vue'
import auto from './details/auto.vue'
import habitation from './details/habitation.vue'
export default {
    props: ['content','identity', 'ga'],
    components:{ voyage, auto, habitation },
    data: () => ({
        subscription: {},
        user: {},
        guarantees: []
    }),
    created(){
        try {
            this.subscription = this.content ? JSON.parse(this.content) : null;
            this.user = this.identity ? JSON.parse(this.identity) : null;
            this.guarantees = this.ga ? JSON.parse(this.ga) : [];
        } catch (e) {
            console.error("Erreur lors du parsing des données de souscription", e);
            this.subscription = null;
            this.user = null;
        }
    }
}
</script>
